import { NetworkState } from '../../constants';
import { NotificationId } from '../../types';
import { NOTIFICATION_DELAYS_MS } from './constants';

export function getNetworkNotificationToHide(state: NetworkState): NotificationId | null {
    switch (state) {
        case NetworkState.OFFLINE:
            return NotificationId.OFFLINE;
        case NetworkState.RECONNECTING:
            return NotificationId.RECONNECTING;
        case NetworkState.ONLINE:
            return null;
        default:
            return null;
    }
}

export function shouldShowNetworkNotification(currentState: NetworkState, targetState: NetworkState): boolean {
    return currentState !== targetState;
}

export function isDegradedState(state: NetworkState): boolean {
    return state === NetworkState.OFFLINE || state === NetworkState.RECONNECTING;
}

export function calculateRemainingDelay(targetState: NetworkState, degradedStateStartTimestamp: number | null): number {
    if (degradedStateStartTimestamp === null) {
        return NOTIFICATION_DELAYS_MS[targetState];
    }

    const elapsed = Date.now() - degradedStateStartTimestamp;
    const totalDelay = NOTIFICATION_DELAYS_MS[targetState];
    const remaining = totalDelay - elapsed;

    return Math.max(0, remaining);
}
